import { c as _c } from "react/compiler-runtime";
import { FormInput, FormSelect, Popover, PrimaryButton } from '@systemeio/ui';
import { QuestionMarkIcon, SettingsIcon } from '@systemeio/ui/icons';
import { FUNNELS_API, updateFunnel } from 'modules/funnels/api/funnels-api';
import { useOfferFormSettingsMutation } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/hooks/use-offer-form-settings';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { FunnelApiInterface, FunnelEditableErrorsInterface, FunnelEditableInterface, FunnelId } from 'modules/funnels/types/funnel-interface';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import EditModal from 'shared/components/edit-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useMutationUpdate } from 'shared/hooks/use-mutation-update';
import { usePaymentMethodsByCurrency } from 'shared/hooks/use-payment-methods-by-currency';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useUser from 'shared/hooks/use-user';
import useUserDomains from 'shared/hooks/use-user-domains';
import { fetchWithFieldErrors } from 'shared/utils/fetch-with-errors';
import { getDomainInfoLink } from 'shared/utils/get-domain-info-link';
import { allowedPaymentMethodsFunnels } from '../constants/allowed-payment-methods';
const defaultErrors: FunnelEditableErrorsInterface = {
  fields: {
    name: '',
    domain: '',
    currency: '',
    paymentMethods: ''
  }
};
const defaultValues: FunnelEditableInterface = {
  name: '',
  domain: undefined,
  currency: undefined,
  paymentMethods: undefined
};
function EditFunnelModal() {
  const $ = _c(61);
  const router = useRouter();
  const [errors, setErrors] = useState(defaultErrors);
  const [tempState, setTempState] = useState(defaultValues);
  const [opened, setOpened] = useState(false);
  const {
    t
  } = useLocoTranslation();
  const funnelId = parseInt(router.query.funnelId as string) as FunnelId;
  const {
    funnelStepsList
  } = useFunnelStepsList(funnelId);
  const {
    clearCurrencyRelatedFields
  } = useOfferFormSettingsMutation();
  const {
    user
  } = useUser();
  const {
    userDomainsSelect
  } = useUserDomains();
  const {
    funnel,
    mutateFunnel
  } = useFunnel(funnelId);
  const mutationUpdate = useMutationUpdate();
  let t0;
  if ($[0] !== t) {
    t0 = t("dashboard.funnel.currency_change_info");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = funnel?.currency;
  let t2;
  if ($[2] !== errors.fields || $[3] !== t0 || $[4] !== t1) {
    t2 = {
      currencyChangeMessage: t0,
      currency: t1,
      errors: errors.fields,
      allowedPaymentMethods: allowedPaymentMethodsFunnels
    };
    $[2] = errors.fields;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    currencyAndPaymentMethodsEditFields,
    isReady
  } = usePaymentMethodsByCurrency(t2);
  const t3 = `${FUNNELS_API}/${funnelId}`;
  const t4 = `${FUNNELS_API}/${funnelId}/steps/list`;
  const t5 = `${FUNNELS_API}/${funnelId}/steps/`;
  const t6 = `${FUNNELS_API}/${funnelId}/stats/`;
  const t7 = `${FUNNELS_API}/${funnelId}/leads/`;
  let t8;
  if ($[6] !== t4 || $[7] !== t5 || $[8] !== t6 || $[9] !== t7) {
    t8 = [`${FUNNELS_API}/list`, `${FUNNELS_API}/get-payment-methods`, `${FUNNELS_API}/step-remote-form`, t4, t5, t6, t7];
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t3 || $[12] !== t8) {
    t9 = {
      api: t3,
      constantApi: t8
    };
    $[11] = t3;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const updateData = useUpdateData(t9);
  let t10;
  if ($[14] !== clearCurrencyRelatedFields || $[15] !== funnel || $[16] !== funnelId || $[17] !== funnelStepsList || $[18] !== mutateFunnel || $[19] !== mutationUpdate || $[20] !== updateData) {
    t10 = async data => {
      await fetchWithFieldErrors(async () => {
        const newData = {
          name: data.name,
          paymentMethods: data.paymentMethods,
          domain: data.domain,
          currency: data.currency
        };
        const response = await updateFunnel(Number(funnelId), newData);
        await updateData(false, undefined, {
          mutationData: funnel,
          onMutate: async () => {
            await mutateFunnel(data_0 => {
              if (data_0) {
                return {
                  ...data_0,
                  name: response.data.name,
                  domain: response.data.domain,
                  paymentMethods: response.data.paymentMethods,
                  currency: response.data.currency
                };
              }
            }, false);
          }
        }, {
          id: funnel?.id,
          onMutate: async apiKey => {
            await mutationUpdate(apiKey, data_1 => data_1 && {
              hasMore: data_1.hasMore,
              items: data_1.items.map(item => {
                if (item.id === response.data.id) {
                  item = {
                    ...item,
                    name: response.data.name
                  };
                }
                return item;
              })
            });
          }
        });
        if (funnel?.currency !== response.data.currency) {
          if (!funnelStepsList) {
            return;
          }
          await clearCurrencyRelatedFields(funnelStepsList.map(_temp));
        }
      }, setErrors);
    };
    $[14] = clearCurrencyRelatedFields;
    $[15] = funnel;
    $[16] = funnelId;
    $[17] = funnelStepsList;
    $[18] = mutateFunnel;
    $[19] = mutationUpdate;
    $[20] = updateData;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const onUpdateFunnel = t10;
  let t11;
  let t12;
  if ($[22] !== funnel) {
    t11 = () => {
      if (funnel) {
        setTempState(prev => ({
          ...prev,
          name: funnel.name,
          currency: funnel.currency,
          domain: funnel.domain.id,
          paymentMethods: funnel.paymentMethods
        }));
      }
    };
    t12 = [funnel];
    $[22] = funnel;
    $[23] = t11;
    $[24] = t12;
  } else {
    t11 = $[23];
    t12 = $[24];
  }
  useEffect(t11, t12);
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => {
      setOpened(true);
    };
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = !funnel;
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SettingsIcon className="fill-background-secondary" />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t) {
    t16 = t("dashboard.funnel.funnel_settings");
    $[27] = t;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t16) {
    t17 = <span className="hidden lg:flex">{t16}</span>;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t14 || $[32] !== t17) {
    t18 = <PrimaryButton onClick={t13} disabled={t14} data-test-element="funnel-settings-button">{t15}{t17}</PrimaryButton>;
    $[31] = t14;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t) {
    t19 = t("dashboard.funnel.edit_funnel");
    $[34] = t;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = () => {
      setOpened(false);
    };
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  const t21 = !funnel || !isReady;
  let t22;
  if ($[37] !== errors.fields || $[38] !== t) {
    t22 = {
      field: "name",
      onRender: (value, onChange, _, __, isPreFetching) => <FormInput key="funnel-edit-name" isPreFetching={isPreFetching} value={value} onChange={e => onChange(e.target.value)} label={t("global.name")} error={errors.fields.name} />
    };
    $[37] = errors.fields;
    $[38] = t;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== errors.fields || $[41] !== t || $[42] !== user?.dashboardLocale || $[43] !== userDomainsSelect) {
    t23 = {
      field: "domain",
      onRender: (value_0, onChange_0, __0, ___0, isPreFetching_0) => <FormSelect isPreFetching={isPreFetching_0} key="funnel-domain-edit" label={<div className="flex w-fit items-center gap-1">{t("dashboard.funnel.funnel_domain")}<Popover label={<TransLoco t={t} i18nKey="dashboard.funnel.domain_tooltip-2" components={{
          a: <a rel="noreferrer" target="_blank" className="primary-link w-full" href={getDomainInfoLink(user?.dashboardLocale)} />
        }} />} popoverClassName="w-[200px] sm:w-[350px]">{_temp2}</Popover></div>} data={userDomainsSelect} onChange={data_2 => onChange_0(data_2)} value={value_0} error={errors.fields.domain} withoutCloseIcon={true} />
    };
    $[40] = errors.fields;
    $[41] = t;
    $[42] = user?.dashboardLocale;
    $[43] = userDomainsSelect;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== currencyAndPaymentMethodsEditFields || $[46] !== t22 || $[47] !== t23) {
    t24 = [t22, t23, ...currencyAndPaymentMethodsEditFields];
    $[45] = currencyAndPaymentMethodsEditFields;
    $[46] = t22;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== onUpdateFunnel) {
    t25 = data_3 => onUpdateFunnel(data_3);
    $[49] = onUpdateFunnel;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== opened || $[52] !== t19 || $[53] !== t21 || $[54] !== t24 || $[55] !== t25 || $[56] !== tempState) {
    t26 = <EditModal fullCaption={t19} opened={opened} onClose={t20} instance={tempState} isPreFetching={t21} editable={t24} onEdit={t25} />;
    $[51] = opened;
    $[52] = t19;
    $[53] = t21;
    $[54] = t24;
    $[55] = t25;
    $[56] = tempState;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== t18 || $[59] !== t26) {
    t27 = <>{t18}{t26}</>;
    $[58] = t18;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  return t27;
}
function _temp2(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp(step) {
  return step.id;
}
export default EditFunnelModal;